export default {
  dateFormat: {
    DD_MON_YYYY: { year: 'numeric', month: 'short', day: 'numeric' },
    DD_MONTH_YYYY: { year: 'numeric', month: 'long', day: 'numeric' },
    DAY_DD_MON_YYYY: { year: 'numeric', month: 'short', day: 'numeric', weekday: 'long' },
    DD_MON_YYYY_HH_MM: { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', hourCycle: 'h23', minute: '2-digit' }
  },
  timeZone: {
    IST: 'IST',
    IST_OFFSET: -330,
    WIB: 'WIB',
    WIB_OFFSET: -420,
    WITA: 'WITA',
    WITA_OFFSET: -480,
    WIT: 'WIT',
    WIT_OFFSET: -540,
    UTC: 'UTC',
    UTC_OFFSET: 0
  },
  media: {
    COMMON_FILE_SIZE: 10,
    MAX_ALLOWED_FILES: 20,
    MAX_IMAGE_ITERATION_COUNT: 15
  },
  components: {
    BLI_LABEL_INFO: 'BliLabelInfo',
    BLI_LABEL_DISABLED: 'BliLabelDisabled',
    BLI_LABEL_WARNING: 'BliLabelWarning',
    BLI_LABEL_SUCCESS: 'BliLabelSuccess',
    BLI_LABEL_DANGER: 'BliLabelDanger'
  },
  registrationSubSection: {
    COMPANY_INFO: 'COMPANY_CONTACT',
    BUSINESS_ENTITY_REPRESENTATIVE: 'DIRECTOR_CONTACT',
    COMPANY_PIC: 'COMPANY_PIC_INFO',
    ACCOUNT_INFO: 'BANK_ACCOUNT_DATA',
    LEGAL_DOCUMENTS: 'DATA_DOCUMENTS',
    REGISTRATION_DOCUMENT: 'REGISTRATION_FORM',
    CREDIT_REQUEST: 'CREDIT_REQUEST_FORM'
  },
  registration: {
    // Company info section
    COMPANY_INFO: 'COMPANY_INFO',
    COMPANY_CONTACT: 'COMPANY_CONTACT',
    COMPANY_ADDRESS: 'COMPANY_ADDRESS',
    // Business entity representative section
    BUSINESS_ENTITY_REPRESENTATIVE: 'BUSINESS_ENTITY_REPRESENTATIVE',
    DEALER_REGISTRATION: 'DEALER_REGISTRATION',
    DIRECTOR_CONTACT: 'DIRECTOR_CONTACT',
    DIRECTOR_DOCUMENT_PHOTO: 'DIRECTOR_DOCUMENT_PHOTO',
    // Company PIC section
    COMPANY_PIC: 'COMPANY_PIC',
    COMPANY_PIC_INFO: 'COMPANY_PIC_INFO',
    // Account info section
    ACCOUNT_INFO: 'ACCOUNT_INFO',
    BANK_ACCOUNT_DATA: 'BANK_ACCOUNT_DATA',
    // Legal documents section
    LEGAL_DOCUMENTS: 'LEGAL_DOCUMENTS',
    DATA_DOCUMENTS: 'DATA_DOCUMENTS',
    PHOTO_DOCUMENTS: 'PHOTO_DOCUMENTS',
    // Upload registration documents section
    REGISTRATION_DOCUMENT: 'REGISTRATION_DOCUMENT',
    REGISTRATION_FORM: 'REGISTRATION_FORM',
    // Credit request section
    CREDIT_REQUEST: 'CREDIT_REQUEST',
    CREDIT_REQUEST_FORM: 'CREDIT_REQUEST_FORM',
    ACCOUNT_NOT_REGISTERED: 'ACCOUNT_NOT_REGISTERED'
  },
  TNC_TYPES: {
    REGISTRATION: 'registration'
  },
  registrationStep: {
    COMPANY_CONTACT: 'company_contact',
    COMPANY_ADDRESS: 'company_address',
    APPLE_ACCOUNT: 'apple_account',
    DIRECTOR_INFO: 'director_info',
    DIRECTOR_DOCS: 'director_docs',
    SUPPORT_DOCS: 'supporting_docs',
    DIRECTOR_ADDRESS: 'director_address',
    COMPANY_PIC: 'company_pic',
    ACCOUNT_INFO: 'account_info',
    LEGAL_DOCS: 'legal_docs',
    PHOTO_DOCS: 'photo_docs',
    REGISTRATION_FORM: 'registration_form',
    CREDIT_REQUEST: 'credit_limit_info'
  },
  charLength: {
    TEXT_FIELD: 100,
    TEXT_AREA: 250,
    PHONE_NUMBER_MAX_0: 15,
    PHONE_NUMBER_MAX_62: 16,
    FAX_NUMBER_MAX_0: 15,
    FAX_NUMBER_MAX_62: 16,
    POSTAL_CODE: 5,
    POSTAL_CODE_MAX: 10,
    SWIFT_CODE: 16,
    KTP_NUMBER: 16,
    NPWP_NUMBER: 16,
    CREDIT_LIMIT: 13,
    PASSWORD: 16,
    OCCUPYING_TIME: 3,
    NPWP_MIN_NUMBER: 15
  },
  company: {
    section: {
      COMPANY_INFO: 'companyInfo',
      BUSINESS_ENTITY_REP: 'businessEntityRep',
      COMPANY_PIC: 'companyPIC',
      LEGAL_DOCUMENTS: 'legalDocuments',
      REGISTRATION_DOCUMENTS: 'registrationDocuments'
    },
    buildingStatus: {
      OTHERS: 'Lainnya',
      OWN: 'Milik sendiri',
      RENT: 'Sewa'
    },
    picRoles: {
      DIRECTOR: 'DIRECTOR',
      REPRESENTATIVE: 'REPRESENTATIVE',
      FINANCE: 'FINANCE',
      SALES: 'SALES',
      OPERATIONAL: 'OPERATIONAL',
      PURCHASING: 'PURCHASING',
      OTHERS: 'OTHERS'
    }
  },
  creditLimit: {
    paymentMethodOptions: {
      CBD: 'CBD',
      SEVEN_DAYS: 'SEVEN_DAYS',
      TEN_DAYS: 'TEN_DAYS',
      FOURTEEN_DAYS: 'FOURTEEN_DAYS',
      TWENTY_ONE_DAYS: 'TWENTY_ONE_DAYS',
      THIRTY_DAYS: 'THIRTY_DAYS'
    }
  },
  errorType: {
    TEXT: 'TEXT',
    NUMBER: 'NUMBER',
    EMAIL: 'EMAIL',
    PASSWORD: 'PASSWORD',
    REPEAT_PASSWORD: 'REPEAT_PASSWORD',
    ALPHA_NUMERIC: 'ALPHA_NUMERIC',
    PHONE_NUMBER: 'PHONE_NUMBER',
    EQUAL_DIGITS: 'EQUAL_DIGITS',
    FILE: 'FILE',
    NPWP_NUMBER: 'NPWP_NUMBER',
    POSTAL_CODE: 'POSTAL_CODE'
  },
  errorResponse: {
    EMAIL_VERIFICATION_PENDING: 'EMAIL_VERIFICATION_PENDING',
    EMAIL_VERIFICATION_LINK_EXPIRED_RESEND: 'EMAIL_VERIFICATION_LINK_EXPIRED_RESEND',
    PRODUCT_DISABLED: 'PRODUCT_DISABLED',
    COMPANY_ADDRESS: 'COMPANY_ADDRESS',
    DIRECTOR_PHONE_NUMBER_INVALID: 'DIRECTOR_PHONE_NUMBER_INVALID'
  },
  VERIFICATION_MAIL_NOT_SENT: 'VERIFICATION_MAIL_NOT_SENT',
  RESET_PASSWORD_MAIL_NOT_SENT: 'RESET_PASSWORD_MAIL_NOT_SENT',
  companyRegistrationStatus: {
    APPROVED: 'APPROVED',
    APPROVAL_PENDING: 'APPROVAL_PENDING',
    REJECTED: 'REJECTED',
    EMAIL_VERIFICATION_DONE: 'EMAIL_VERIFICATION_DONE'
  },
  regex: {
    alphabet: /^[A-Za-z ]+$/,
    number: /^\d+$/,
    email: /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
    phoneNumber: /^(0|62)\d{8,14}$/,
    alphaNumeric: /^[A-Za-z0-9]+$/
  },
  companyAddress: {
    buildingStatus: {
      OWN: 'OWN',
      RENT: 'RENT',
      OTHERS: 'OTHERS'
    }
  },
  productAttributes: {
    COLOR: 'color',
    CAPACITY: 'capacity',
    SIZE: 'size',
    PROCESSOR: 'processor',
    MODEL: 'model'
  },
  order: {
    QUOTATION_STATUS: 'QUOTATION_STATUS',
    orderList: {
      RECORDS_PER_PAGE: 10
    },
    status: {
      ALL_STATUS: 'ALL_STATUS',
      QUOTATION_CREATED: 'QUOTATION_CREATED',
      QUOTATION_PROCESSED: 'QUOTATION_PROCESSED',
      QUOTATION_APPROVED: 'QUOTATION_APPROVED',
      QUOTATION_REJECTED: 'QUOTATION_REJECTED',
      QUOTATION_EXPIRED: 'QUOTATION_EXPIRED',
      QUOTATION_APPROVAL: 'QUOTATION_APPROVAL',
      PO_CREATED: 'PO_CREATED',
      IN_PACKING: 'IN_PACKING',
      IN_DELIVERY: 'IN_DELIVERY',
      DELIVERED: 'DELIVERED',
      ORDER_COMPLETED: 'ORDER_COMPLETED',
      APPROVED: 'DEALER_APPROVED',
      REJECTED: 'DEALER_REJECTED'
    },
    errorCode: {
      USER_DAILY_OTP_RESEND_LIMIT_EXCEEDED: 'USER_DAILY_OTP_RESEND_LIMIT_EXCEEDED',
      QUOTATION_OTP_VERIFICATION_IN_PROGRESS: 'QUOTATION_OTP_VERIFICATION_IN_PROGRESS',
      WRONG_OTP: 'WRONG_OTP',
      OTP_VERIFIED: 'OTP_VERIFIED',
      USER_VERIFY_LIMIT_EXCEEDED: 'USER_VERIFY_LIMIT_EXCEEDED',
      OTP_RESEND_COUNT_LIMIT_REACHED: 'OTP_RESEND_COUNT_LIMIT_REACHED',
      CANNOT_VERIFY_OTP: 'CANNOT_VERIFY_OTP'
    }
  },
  rewards: {
    status: {
      ACCEPTED: 'ACCEPTED',
      WAITING: 'WAITING',
      REJECTED: 'REJECTED'
    },
    cermati: {
      CERMATI_NOT_ACTIVE: 'CERMATI_NOT_ACTIVE',
      CERMATI_ACTIVE: 'CERMATI_ACTIVE',
      CERMATI_POINT_ALLOCATED: 'CERMATI_POINT_ALLOCATED'
    },
    pointsRange: [
      {
        MIN: 0,
        MAX: 1000,
        VALUE: 'RANGE_0_TO_1000'
      },
      {
        MIN: 1000,
        MAX: 5000,
        VALUE: 'RANGE_1000_TO_5000'
      },
      {
        MIN: 5000,
        MAX: Infinity,
        VALUE: 'RANGE_5000_ABOVE'
      }

    ],
    pointsHistoryList: {
      RECORDS_PER_PAGE: 10
    },
    giftList: {
      RECORDS_PER_PAGE: 10
    }
  },
  gift: {
    status: {
      ALL_STATUS: 'ALL_STATUS',
      GIFT_WAITING: 'GIFT_WAITING',
      GIFT_IN_PROGRESS: 'GIFT_IN_PROGRESS',
      GIFT_APPROVED: 'GIFT_APPROVED',
      GIFT_REJECTED: 'GIFT_REJECTED'
    }
  },
  rewardsDetail: {
    status: {
      FILED: 'FILED',
      ACCEPTED: 'ACCEPTED',
      REJECTED: 'REJECTED',
      NOT_FILED: 'NOT_FILED',
      WAITING: 'WAITING'
    }
  },
  SESSION_UPDATED_DATE: 'sessionUpdatedDate',
  FCM_TOKEN: 'fcm_token',
  FCM_TOKEN_TIMESTAMP: 'fcm_token_timestamp'
}
